import redWatsapp from "./watsapp/redWatsapp.jpg";
import blueWatsapp from "./watsapp/blueWatsapp.jpg";
import react, { Component } from "react";
import domtoimage from "dom-to-image";
import { saveAs } from "file-saver";
import googleImg from "../postertypes/watsapp/GOOGLE.png";
import html2canvas from "html2canvas";

import "./watsappPhoto.css";

import React from "react";

const WatsappPhoto = ({ props }) => {
  const state = {
    appName: props.appName,
    courseName: `${props.courseName} Course`,
    coursePrice: `at just ₹ ${props.coursePrice}/-`,

    color: props.color,
    educatorPhoto: props.educatorPhoto,
    appLogo: props.appLogo,
    contactNumber: props.contactNumber,
  };

  const download = () => {
    // domtoimage
    //   .toBlob(document.getElementById("watsapp"), {
    //     quality: 0.7,
    //     // height: 512,
    //     // width: 942,
    //   })
    //   .then((blob) => {
    //     saveAs(blob, "poster.jpg");
    //   });

    var container = document.getElementById("watsapp"); //specific element on page
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    // var container = document.getElementById("htmltoimage");; // full page
    html2canvas(container, { allowTaint: true }).then(function (canvas) {
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.download = "Poster.png";
      link.href = canvas.toDataURL("image/png");
      link.target = "_blank";
      link.click();
    });
  };

  return (
    <div className="watsappContainer">
      <div
        className="watsapp"
        id="watsapp"
        style={
          state.color == "blue"
            ? { backgroundImage: `url(${blueWatsapp})` }
            : state.color == "red"
            ? { backgroundImage: `url(${redWatsapp})` }
            : state.color == ""
            ? { backgroundImage: `url(${redWatsapp})` }
            : ""
        }
      >
        <div className="appName-logo-watsapp">
          <span id="appName-watsapp">{state.appName}</span>
          <img id="appLogo-watsapp" src={state.appLogo}></img>
        </div>
        <div className="detailsDisplay-watsapp">
          <div className="left-watsapp">
            <img src={state.educatorPhoto} id="educatorPhoto-watsapp" />
          </div>
          <div className="right-watsapp">
            <span id="launching-watsapp">Launching</span>
            <span id="courseName-watsapp">{state.courseName}</span>
            <span id="coursePrice-watsapp">{state.coursePrice}</span>
            <button id="buyNowCta">Buy Now</button>
          </div>
        </div>

        <div className="bottom-watsapp">
          <div className="contactDiv">
            <span className="contactUs">Contact Us</span>
            <span id="contactDisplay-watsapp">{state.contactNumber}</span>
          </div>
          <div className="hashtagGoogle">
            <img src={googleImg} className="googleImg" />
            <span id="hashtag-watsapp">#PadhaiNahiRukegi</span>
          </div>
        </div>
      </div>

      <button id="bannerCta-watsapp" onClick={download}>
        Click To Download
      </button>
    </div>
  );
};
export default WatsappPhoto;
